<template>
  <b-row>
    <h6 class="pl-12 pt-20 fs-20 title-color">
      <b>Checkbox Options</b>
    </h6>
    <b-row class="pt-18">
      <b-col cols="12" class="fs-13 text-color" align-self="center">
        <b>Field Requirement.</b>
      </b-col>
      <b-col class="fs-15" align-self="center">
        <b-form-checkbox @change="checkBoxData.required = !checkBoxData.required" v-model="checkBoxData.required" class="pl-0"> <span class="pl-25 text-align">Required</span> </b-form-checkbox><br />
        <b-form-checkbox @change="checkBoxData.colorCodeEnabled = !checkBoxData.colorCodeEnabled" v-model="checkBoxData.colorCodeEnabled" class="pl-0"> <span class="pl-25 text-align fs-15">Add color-coded alerts to answers for the study team</span> </b-form-checkbox><br />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <hr />
      </b-col>
      <b-col cols="12" class="pt-8 fs-13">
        <b>Field Name</b>
      </b-col>
      <b-col cols="12" class="pt-10 fs-15">
        You may name this field for the purposes of data mapping. It will not be visible to the Site Team(s) or participants.
      </b-col>
      <b-col cols="12 pt-8">
        <b-form-input type="text" v-model="checkBoxData.fieldName" placeholder="Enter field name" class="field-h40 form-control fs-15" size="sm" v-bind:class="{ 'is-danger': checkBoxData.fieldNameErrorMsg }" v-on:keyup.native="checkForErrors" autocomplete="off"></b-form-input>
        <span class="error-style" v-if="checkBoxData.fieldNameErrorMsg">{{ checkBoxData.fieldNameErrorMsg }}</span>
      </b-col>
    </b-row>
  </b-row>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import findIndex from "lodash/findIndex";
import filter from "lodash/filter";
import find from "lodash/find";

import schemas from "../../../data/form-components-json/schemas.json";

export default {
  name: "check-box-prop",
  data() {
    return {
      checkBoxData: [],
      choicesGiven: [],
      hideAddNotification: true,
      notifications: [],

      notificationSchema: find(schemas, "fieldType", "CheckBox").schemas.notificationSchema
    };
  },
  props: ["checkboxSchema"],
  mounted() {
    this.checkBoxData = this.checkboxSchema;
    this.notifications = this.checkBoxData.notifications;
  },
  methods: {
    addNewNotification() {
      const notificationSchema = cloneDeep(this.notificationSchema);
      notificationSchema.notificationConditionFlag = false;
      notificationSchema.notificationContactFlag = false;
      this.notifications.push(notificationSchema);
      this.hideAddNotification = !this.hideAddNotification;
    },

    saveNotification(index) {
      this.notifications[index].notificationContactFlag = false;
      this.notifications[index].notificationConditionFlag = false;
      const selectedContactsList = filter(this.notifications[index].contacts, "status", true);
      let modeOfNotificationErroCount = 0;
      // get notifications where contact is selected but no mode of notification ( sms or email)
      selectedContactsList.forEach(contact => {
        if (!contact.sms && !contact.email) {
          modeOfNotificationErroCount += 1;
        }
      });
      // check for the notification trigger condition ( check for the option whether selected )
      if (!this.notifications[index].triggerCondition.selectedOptionVal) {
        this.notifications[index].notificationConditionFlag = true;
      } else if (filter(this.notifications[index].contacts, "status", true).length <= 0) {
        // check if any contact is selected ot not for notification
        this.notifications[index].notificationContactFlag = true;
      } else if (modeOfNotificationErroCount > 0) {
        // check notifications where contact is selected but no mode of notification ( sms or email)
        const selectedContacts = filter(this.notifications[index].contacts, "status", true);
        selectedContacts.forEach(contact => {
          if (!contact.sms && !contact.email) {
            this.notifications[index].notificationContactFlag = true;
          }
        });
      } else {
        this.notifications[index].mode = !this.notifications[index].mode;
        this.hideAddNotification = !this.hideAddNotification;
        this.choicesGiven[index].disabled = true;
        this.checkBoxData.notifications = this.notifications;
        this.checkBoxData.notifications[index].name = `${this.checkBoxData.notifications[index].name} ${index + 1}`;
      }
    },

    removeNotification(index) {
      this.choicesGiven[index].disabled = false;
      this.notifications.splice(index, 1);
      const tempNotifications = this.notifications;
      this.notifications = [];
      tempNotifications.forEach((notification, ind) => {
        const tempNotification = notification;
        tempNotification.name = `Notification ${ind + 1}`;
        this.notifications.push(tempNotification);
      });
      this.checkBoxData.notifications = this.notifications;
    },

    addContact(index) {
      this.notifications[index].contacts.push({
        status: true,
        name: "Sari Patel(PhV)",
        email: false,
        sms: false
      });
    },

    findOptionVal(index, optIndex) {
      // find choice selected from available choice
      // then store that choice value in notification data
      if (!this.choicesGiven[findIndex(this.choicesGiven, ["index", optIndex])]) {
        if (this.notifications[index]) {
          this.notifications[index].triggerCondition.selectedOptionVal = "";
        }
      } else {
        this.notifications[index].triggerCondition.selectedOptionVal = this.choicesGiven[findIndex(this.checkBoxData.choices, ["index", optIndex])].text;
      }
    },

    checkForErrors() {
      if (this.checkBoxData.fieldName && this.checkBoxData.fieldName.trimEnd().length > 0) {
        this.checkBoxData.fieldNameErrorMsg = "";
      }
    }
  }
};
</script>

<style scoped lang="scss">
.text-align {
  line-height: 23px !important;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}

.is-danger {
  border-color: #ff4848;
}

/deep/.vue-switcher-theme--custom.vue-switcher-color--blue div {
  background-color: #1e8fe1;
  height: 9px;
  width: 33px;
}
/deep/.vue-switcher-theme--custom.vue-switcher-color--blue div:after {
  background-color: #ffffff;
  border: 1px solid #1e8fe1;
  height: 15px;
  width: 15px;
  margin-left: -15px;
}
/deep/.vue-switcher-theme--custom.vue-switcher-color--blue.vue-switcher--unchecked div {
  background-color: #d5d7dc;
  height: 9px;
  width: 33px;
}
/deep/.vue-switcher-theme--custom.vue-switcher-color--blue.vue-switcher--unchecked div:after {
  background-color: #ffffff;
  border: 1px solid #1e8fe1;
  height: 15px;
  width: 15px;
}
</style>
